import { useState } from 'react';
import { Alert, Button, Stack } from '@mui/material';
import { Icon } from '@zenput/legacy-ui-components';

interface ErrorFooterAlertProps {
    errors: Record<string, unknown>;
    requiredOrderedFields: string[];
}

export const ErrorFooterAlert = (props: ErrorFooterAlertProps) => {
    const { errors, requiredOrderedFields } = props;

    const [currentErrorIndex, setCurrentErrorIndex] = useState(0);
    const activeErrors = requiredOrderedFields.filter((fieldName) => errors[fieldName]);

    const navigateToError = (index: number) => {
        const fieldName = activeErrors[index];
        const element = document.getElementById(fieldName);

        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            element.focus({ preventScroll: true });
        }
    };

    const handleNext = () => {
        const nextIndex = (currentErrorIndex + 1) % activeErrors.length;
        setCurrentErrorIndex(nextIndex);
        navigateToError(nextIndex);
    };

    const handleBack = () => {
        const prevIndex = currentErrorIndex === 0 ? activeErrors.length - 1 : currentErrorIndex - 1;
        setCurrentErrorIndex(prevIndex);
        navigateToError(prevIndex);
    };

    return (
        <Alert
            action={
                <Stack direction="row" spacing={1}>
                    <Button
                        color="inherit"
                        disabled={currentErrorIndex === 0}
                        onClick={handleBack}
                        size="small"
                        variant="outlined"
                    >
                        <Icon variant="df-arrow-left" className="icon" size={18} />
                    </Button>
                    <Button
                        color="inherit"
                        disabled={currentErrorIndex === requiredOrderedFields.length - 1}
                        onClick={handleNext}
                        size="small"
                        variant="outlined"
                    >
                        <Icon variant="df-arrow-right" className="icon" size={18} />
                    </Button>
                </Stack>
            }
            severity="error"
            sx={{ alignItems: 'center', width: '100%' }}
            variant="filled"
        >
            {_t('mobile_forms_required_remaining', {
                count: Object.keys(errors).length
            })}
        </Alert>
    );
};
